import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { BASE_PATH } from "@/data/basePath";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Collection from "@/pages/Collection";
import CarDetail from "@/pages/CarDetail";
import Drives from "@/pages/Drives";
import Memories from "@/pages/Memories";
import Videos from "@/pages/Videos";
import Artwork from "@/pages/Artwork";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App bg-noise">
      <BrowserRouter basename={BASE_PATH || undefined}>
        <ScrollToTop />
        <Nav />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/collection" element={<Collection />} />
            <Route path="/collection/:slug" element={<CarDetail />} />
            <Route path="/drives" element={<Drives />} />
            <Route path="/memories" element={<Memories />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/artwork" element={<Artwork />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
